<div class="support-container">
    <app-chat-markdown class="support-content" [html]="supportData.content"></app-chat-markdown>
</div>
